import { hideLoading } from "App/Loading/Store/actions";
import React, { useEffect, useRef } from "react";
import { useDispatch } from "react-redux";

function parseOrderId(search) {
  const params = new URLSearchParams(search);
  return params.get("vads_order_id") || null;
}

// AYB 2026.02.09 - Page retour Payzen : on transmet uniquement l'orderId au parent ; la validité du paiement est jugée côté parent via GET pre_achats, pas sur le retour window
function Paiement() {
  const dispatch = useDispatch();
  const hasSent = useRef(false);

  useEffect(() => {
    if (hasSent.current) return;
    hasSent.current = true;
    const orderId = parseOrderId(window.location.search);
    // AYB 2026.02.09 - Pas de success/data dans le message : le parent valide via GET idachat uniquement
    window.top.postMessage({ text: "payzen result", orderId: orderId || null }, "*");
    dispatch(hideLoading());
  }, [dispatch]);

  return (
    <div style={{ height: "100%", display: "flex", alignItems: "center", justifyContent: "center" }}>
    </div>
  );
}

export { Paiement };
